import { AppBar, Box, Toolbar } from '@material-ui/core';
import AccountIcon from '@material-ui/icons/AccountCircleOutlined';
import React from 'react';
import WileyLogo from 'assets/img/WileyLogo.png';
import lang from './ConnectLayout.lang.json';
import './ConnectLayout.scss';
import useConnectAuth from './hooks/useConnectAuth';
import links from './links';

function ConnectLayout({ children }) {
  const { startConnectLogin } = useConnectAuth();

  return (
    <>
      <AppBar className="connect-layout__header">
        <Toolbar className="connect-layout__header__toolbar">
          <Box className="connect-layout__header__logo-box">
            <img alt={lang.logoAlt} className="connect-layout__header__logo" src={WileyLogo} />
          </Box>

          <Box className="connect-layout__header__title">{lang.appName}</Box>

          <Box className="connect-layout__header__login">
            <a data-testid="connect-header-login-link" onClick={startConnectLogin}>
              <Box className="connect-layout__header__login-text">{lang.login}</Box>

              <AccountIcon className="connect-layout__header__login-icon" />
            </a>
          </Box>
        </Toolbar>
      </AppBar>

      <Box className="connect-layout__content-box">
        <Box className="connect-layout__outlet">{children}</Box>

        <Box className="connect-layout__footer">
          <Box className="connect-layout__footer__copyright">
            {lang.copyright}
            <br />

            {lang.copyrightNotice}
          </Box>

          <Box className="connect-layout__footer__links">
            <a
              data-testid="connect-footer-privacy-policy-link"
              href={links.privacyPolicy.url}
              target={links.privacyPolicy.target}
            >
              {links.privacyPolicy.text}
            </a>

            <a
              data-testid="connect-footer-terms-of-use-link"
              href={links.termsOfUse.url}
              target={links.termsOfUse.target}
            >
              {links.termsOfUse.text}
            </a>

            <a data-testid="connect-footer-cookies-link" href={links.cookies.url} target={links.cookies.target}>
              {links.cookies.text}
            </a>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ConnectLayout;
